import React from "react";
import {
  Avatar,
  Box,
  Button,
  Col,
  Divider,
  FabButton,
  Flex,
  Gap,
  Row,
  Typography,
} from "../../../ppui";
import { TbPencil } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../../style";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import PaymentModal from "./modal/payment-modal";
import KycModal from "./modal/kyc-modal";
import { SALARY_DETAILS_CONST } from "./pay-kyc-const";


const UpdatePayKyc = ({
  paymentData,
  onChangePayment,
  OnBlurePayment,
  paymentErr,
  onChangeKYCdoc,
  alldocs,
  kycDoc,
  fileInputRef,
  handleButtonClick,
  handleFileChange,
  DeleteSpecificFile,
  openFileInNewTab,
  checkDocName,
  paymentModal,
  PaymentModalToggle,
  onUpdatePayKyc,
  paymentloader,
  kycModalToggle,
  kycMOdal,
}) => {
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Payment Structure
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={PaymentModalToggle}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Salary Type
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
{
   SALARY_DETAILS_CONST?.salary_type?.options?.find((ele)=>ele?.id===paymentData?.salary_type)?.name
}

          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Wages Type
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.wages_type ? paymentData?.wages_type : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Wages Rate
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.wages_rate ? paymentData?.wages_rate : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Wages Payment Mode
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.wages_payment_mode
              ? paymentData?.wages_payment_mode
              : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Wages Days
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.wages_days ? paymentData?.wages_days : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Amount
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.ammount ? paymentData?.ammount : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Payment By
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {
   SALARY_DETAILS_CONST?.payment_by?.options?.find((ele)=>ele?.id===paymentData?.payment_by)?.name
}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Bank Name
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.bank_name ? paymentData?.bank_name : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Branch Name
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.branch_name ? paymentData?.branch_name : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Bank Ac/No.
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.account_number ? paymentData?.account_number : "N/A"}
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            IFSC Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {paymentData?.ifsc_code ? paymentData?.ifsc_code : "N/A"}
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
      <Divider gap={20} />
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5">KYC Document</Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={kycModalToggle}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Flex direction="column" gap={30}>
        {paymentData?.kyc_additional_info?.map((item, index) => (
          <Row rowGap key={index}>
            <Col sm={12} md={4} lg={8}>
              <Flex gap={20}>
                <Box>
                  <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                </Box>
                <Box>
                  <Typography variant="body2" mb={"0"} color={"dark"}>
                    {item?.document_type}
                  </Typography>
                  <Typography variant="h5" mb={"0"}>
                    {item?.document_number}
                  </Typography>
                </Box>
              </Flex>
            </Col>
            <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
              <Flex gap={10}>
                <Button
                  onClick={() => window?.open(item?.attachment, "_blank")}
                  variant="filled"
                  size="sm"
                  color="primary"
                >
                  View
                </Button>
              </Flex>
            </Col>
          </Row>
        ))}
      </Flex>
      <PaymentModal
        paymentData={paymentData}
        onChangePayment={onChangePayment}
        OnBlurePayment={OnBlurePayment}
        paymentErr={paymentErr}
        paymentModal={paymentModal}
        PaymentModalToggle={PaymentModalToggle}
        onUpdatePayKyc={onUpdatePayKyc}
        paymentloader={paymentloader}
      />
      <KycModal
        onUpdatePayKyc={onUpdatePayKyc}
        onChangeKYCdoc={onChangeKYCdoc}
        alldocs={alldocs}
        kycDoc={kycDoc}
        fileInputRef={fileInputRef}
        handleButtonClick={handleButtonClick}
        handleFileChange={handleFileChange}
        DeleteSpecificFile={DeleteSpecificFile}
        openFileInNewTab={openFileInNewTab}
        checkDocName={checkDocName}
        kycModalToggle={kycModalToggle}
        paymentloader={paymentloader}
        kycMOdal={kycMOdal}
      />
    </>
  );
};

export default UpdatePayKyc;
